import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '../../../../components/ui/dialog';
import { ImportantNotesContent } from '../../../../shared/ImportantNotesContent';

interface ImportantNotesDialogProps {
  open: boolean;
  onClose: () => void;
  onComplete: () => void;
}

const ImportantNotesDialog: React.FC<ImportantNotesDialogProps> = ({
  open,
  onClose,
  onComplete
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-[25rem] rounded-3xl sm:max-w-[26rem]">
        <DialogHeader>
          <DialogTitle className="sr-only">Important Notes</DialogTitle>
        </DialogHeader>
        <ImportantNotesContent
          onComplete={onComplete}
          spinnerMessage="Redirecting..."
          spinnerSubMessage="Please do not close or refresh the window, we are redirecting you to link the payment selected."
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImportantNotesDialog;
